const ProfileIcon = require("./ProfileIcon.png");
const Display = require("./Display.png");
const Display2 = require("./Display2.png");
const Exp1 = require("./Exp1.png");
const Exp2 = require("./Exp2.png");
const backgroundImage=require('./back2.png');
const Exp3 = require("./Exp3.png");
const Map = require("./map.jpg");

const StaticImages = {
  ProfileIcon,
  Display,
  Exp1,
  Exp2,
  Exp3,
  backgroundImage,
  Display2,
  Map
};

export default StaticImages;
